
import { Badge, Modal, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleEmailDialog } from './newsletterActions';
import styles from './newsletter.css';

class NewsletterEmailModalComponent extends Component {

  onOk = () => {
    this.props.dispatch(toggleEmailDialog(false));
  }

  handleCancel = () => {
    this.props.dispatch(toggleEmailDialog(false));
  }

  getColor(sentCount) {

    if (sentCount > 0)
      return '#22bb22';
    if (sentCount < 0)
      return '#dd2222';

    return '#777';
  }

  render() {

    if (!this.props.showEmailDialog) {
      return null;
    }

    return (

      <Modal
        title='Statistik'
        visible={true}
        width={1200}
        maskClosable={false}
        onOk={this.onOk}
        onCancel={this.handleCancel}
      >
        <Spin spinning={this.props.loadingEmails}>
          {!this.props.loadingEmails &&
            <div style={{ marginBottom: 50 }}>
              <div style={styles.emailBadge}>
                <Badge count={this.props.sentCount} overflowCount={10000000} showZero style={{ backgroundColor: this.getColor(1) }}>
                  Levererat
              </Badge>
              </div>

              <div style={styles.emailBadge}>
                <Badge count={this.props.notSentCount} overflowCount={10000000} showZero style={{ backgroundColor: this.getColor(0) }}>
                  Ej skickat än
              </Badge>
              </div>
              <div style={styles.emailBadge}>
                <Badge count={this.props.failedCount} overflowCount={10000000} showZero style={{ backgroundColor: this.getColor(-1) }}>
                  Misslyckats
              </Badge>
              </div>
            </div>
          }
          {this.props.emails.map(e => (
            <div style={{ clear: 'both' }}>
              <span style={{ color: this.getColor(e.sentCount) }}>{e.email}</span>
            </div>
          ))}
        </Spin>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showEmailDialog: state.newsletter.showEmailDialog,
    emails: state.newsletter.emails,
    loadingEmails: state.newsletter.loadingEmails,
    notSentCount: state.newsletter.notSentCount,
    sentCount: state.newsletter.sentCount,
    failedCount: state.newsletter.failedCount
  }
};

export default connect(mapStateToProps)(NewsletterEmailModalComponent);


// WEBPACK FOOTER //
// ./src/newsletter/newsletterEmailModalComponent.js